import { Component, Inject } from '@angular/core';
import { ShippingService } from '../../services/api-services/shipping.service';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormService } from '../../services/form.service';

@Component({
  selector: 'app-confirm-add-rx',
  templateUrl: './confirm-add-rx.component.html',
  styleUrl: './confirm-add-rx.component.scss'
})
export class ConfirmAddRxComponent {
  isLoading: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<ConfirmAddRxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private shippingService: ShippingService,
    private toastr: ToastrService,
    private formService: FormService,
  ) {

  }

  get addedRxNum(): string {
    return this.data?.item?.item?.added_rx_num || this.data?.item?.apiData?.rx_number || 'N/A';
  }

  get requestedBrand(): string {
    return this.data?.item?.apiData?.requestedDrugInfo?.brandName || 'N/A';
  }

  get requestedGeneric(): string {
    return this.data?.item?.apiData?.requestedDrugInfo?.genericName || 'N/A';
  }

  get requestedDosage(): string {
    return this.data?.item?.apiData?.requestedDrugInfo?.strength || 'N/A';
  } 
  
  get krollBrand(): string {
    return this.data?.item?.apiData?.kroll_rx_detail?.brandName || 'N/A';
  }

  get krollGeneric(): string {
    return this.data?.item?.apiData?.kroll_rx_detail?.genericName || 'N/A';
  }

  get krollDosage(): string {
    return this.data?.item?.apiData?.kroll_rx_detail?.strength || 'N/A';
  }

  confirm() {
    this.dialogRef.close(true);
  }

  // Add Rx ID to server and refresh list
  add_rx_request_order() {
    if (!this.data || this.data.item.item.added_rx_num == null) {
      this.toastr.error('No Rx ID to add');
      return;
    }
    const payload = {
      user_id: this.data.item.user_id,
      server_location: this.formService.selectedLocation.value,
      search_rx_number: [this.data.item.item.added_rx_num],
      refill_request_id: this.data.item.item.id,
      request_type: this.data.item?.item?.requestType,
    };
    this.isLoading = true;
    this.shippingService.add_rx_request_order(payload).subscribe({
      next: (res: any) => {
        if (res?.body?.success) {
          this.toastr.success(res?.body?.message || 'Rx ID added successfully');
          this.dialogRef.close(res?.body?.success);
          this.isLoading = false;
        } else {
          this.toastr.error(res?.body?.message || 'Failed to add Rx ID');
          this.isLoading = false;
        }
      },
      error: (err: any) => {
        console.error('Server error while adding Rx ID', err);
        this.toastr.error('Server error while adding Rx ID');
        this.isLoading = false;
      }
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
